module.exports = __webpack_public_path__ + "static/media/DSC02856_lakefield_bts_Small.51efc489.jpg";